import axios from 'axios';

/**
 * Based on `SubmitContactFormDto` from libs/shared/contact-form/feature-submit-form/src/lib/submit-contact-form.dto.ts
 */
export type SubmitContactForm = {
  email: string;
  message: string;
  full_name: string;
  subject: string;
  url: string;
  is_embedded: boolean;
  attachments?: {
    filename: string;
    size: number;
    url: string;
  }[];
};
export class ContactService {
  static async submitContactForm(contactForm: SubmitContactForm) {
    return axios.post('/api/contact-form', contactForm);
  }
}
